@if (hasLegalization) {
<app-expansive-leagalization-documents-list [workerId]="this.profile.WorkerId"
  [documentsExpansionHeaderHeight]="documentsExpansionHeaderHeight">
</app-expansive-leagalization-documents-list>
}

@if (isDocumentsOnWorkerProfileVisible() && files$ | async; as files) {
<div>
  <mat-accordion>
    <mat-expansion-panel [expanded]="hasAnyStatementsDocuments">
      <mat-expansion-panel-header [collapsedHeight]="documentsExpansionHeaderHeight"
        [expandedHeight]="documentsExpansionHeaderHeight">
        <mat-panel-title>
          <h2>{{ 'DocumentsBeforeEmployment' | translate }}</h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <!-- Statements -->
      <div class="table-wrapper">
        <table class="five-cols">
          <thead>
            <tr>
              <th class="column-question">{{ 'Question' | translate }}</th>
              <th class="column-filename">{{ 'Name' | translate }}</th>
              <th class="column-date">{{ 'CreatedOnDate' | translate }}</th>
              <th class="column-isattached">{{ 'Status' | translate }}</th>
              <th class="column-actions">{{ 'Actions' | translate }}</th>
            </tr>
          </thead>
          <tbody class="documents-table">
            @for (statement of files?.DocumentStatements; track statement) {
            <tr class="table-row">
              <td class="column-question">{{ statement.QuestionText }}</td>
              @if (statement.Files.length === 0) {
              <td class="column-date"></td>
              <td class="column-filename"></td>
              <td class="column-actions">
                <button mat-icon-button color="primary" (click)="addFile(statement.QuestionId, statement.QuestionText)">
                  <mat-icon>add_box</mat-icon>
                </button>
              </td>
              }
              <td class="column-filename">
                @for (file of statement.Files; track file) {
                <div>
                  @if (file.Id != null) {
                  <a href="javascript:void(0)" (click)="showFile(file.Id, file.Name)">{{
                    file.Name }}</a>
                  }
                </div>
                }
              </td>
              <td class="column-date">
                @for (file of statement.Files; track file) {
                <div>
                  {{ file.AddedDate | date : 'yyyy-MM-dd' }}
                </div>
                }
              </td>
              <td class="column-isattached">
                @if (!statement?.IsDocumentIncluded) {
                <span><mat-icon>error</mat-icon></span>
                }
                @if (statement?.IsDocumentIncluded) {
                <span><mat-icon>check</mat-icon></span>
                }
              </td>
              <td class="column-actions">
                @for (file of statement.Files; track file) {
                <div>
                  @if (file.Id != null) {
                  <button mat-icon-button color="primary" (click)="downloadFile(file.Id, file.Name)">
                    <mat-icon>download</mat-icon>
                  </button>
                  }
                  @if (file.Id == null || statement.AttachmentCountLimit > statement.Files.length) {
                  <button mat-icon-button color="primary"
                    (click)="addFile(statement.QuestionId, statement.QuestionText)">
                    <mat-icon>add_box</mat-icon>
                  </button>
                  }
                  <button mat-icon-button color="primary" [visibleWithPermissions]="['DeleteWorkerFiles']"
                    (click)="deleteFile(file.Id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                }
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion>
    <!--  WorkerFamilyMembers -->
    <mat-expansion-panel *hasPermissionToModule="moduleNames.FamilyMembers; workerId: profile.WorkerId">
      <mat-expansion-panel-header [collapsedHeight]="documentsExpansionHeaderHeight"
        [expandedHeight]="documentsExpansionHeaderHeight">
        <mat-panel-title>
          <h2>{{ 'WorkerFamilyMembersDocuments' | translate }}</h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="document-buttons">
        <button mat-raised-button color="primary" (click)="openWorkerFamilyMembersModal()">
          {{ 'WL-AddDocument' | translate }}
        </button>
      </div>
      <div class="table-wrapper">
        <table class="five-cols">
          <thead>
            <tr>
              <th class="column-fullname">{{ 'FullName' | translate }}</th>
              <th class="column-filename">{{ 'Name' | translate }}</th>
              <th class="column-date">{{ 'CreatedOnDate' | translate }}</th>
              <th class="column-isattached">{{ 'Status' | translate }}</th>
              <th class="column-actions">{{ 'Actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (file of files?.WorkerFamilyMembersFiles | filterPurely : familyMemberFilter; track file) {
            <tr>
              <td class="column-fullname">{{ file?.FullName }}</td>
              <td class="column-filename">
                @for (f of file.Files; track f) {
                <div>
                  <a href="javascript:void(0)" (click)="showFile(f.Id, f.Name, file.WorkerFamilyMemberId)">{{ f.Name
                    }}</a>
                </div>
                }
              </td>
              <td class="column-date">
                @for (f of file.Files; track f) {
                <div>{{ f?.CreatedOn | date : 'yyyy-MM-dd' }}</div>
                }
              </td>
              <td class="column-isattached">
                @if (!file.Files) {
                <span><mat-icon>error</mat-icon></span>
                }
                @if (!!file.Files) {
                <span><mat-icon>check</mat-icon></span>
                }
              </td>
              <td class="column-actions">
                @for (f of file.Files; track f) {
                <div>
                  <button mat-icon-button color="primary"
                    (click)="downloadFile(f.Id, f.Name, file.WorkerFamilyMemberId)">
                    <mat-icon>download</mat-icon>
                  </button>
                </div>
                }
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion *hasPermissionToModule="moduleNames.EducationHistory">
    <!--  EducationHistory -->
    <mat-expansion-panel>
      <mat-expansion-panel-header [collapsedHeight]="documentsExpansionHeaderHeight"
        [expandedHeight]="documentsExpansionHeaderHeight">
        <mat-panel-title>
          <h2>{{ 'EducationHistoryDocuments' | translate }}</h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="document-buttons">
        <button mat-raised-button color="primary" (click)="openEducationHistoryModal()">
          {{ 'WL-AddDocument' | translate }}
        </button>
      </div>
      <div class="table-wrapper">
        <table class="five-cols">
          <thead>
            <tr>
              <th class="column-fullname">{{ 'School' | translate }}</th>
              <th class="column-filename">{{ 'Name' | translate }}</th>
              <th class="column-date">{{ 'CreatedOnDate' | translate }}</th>
              <th class="column-isattached">{{ 'Status' | translate }}</th>
              <th class="column-actions">{{ 'Actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (file of files?.EducationHistoryFiles | filter : educationHistoryFilesFilter; track file) {
            <tr>
              <td class="column-fullname">{{ file?.School }}</td>
              <td class="column-filename">
                @for (f of file.Files; track f) {
                <div>
                  <a href="javascript:void(0)" (click)="showFile(f.Id, f.Name)">{{ f.Name }}</a>
                </div>
                }
              </td>
              <td class="column-date">
                @for (f of file.Files; track f) {
                <div>{{ f?.CreatedOn | date : 'yyyy-MM-dd' }}</div>
                }
              </td>
              <td class="column-isattached">
                @if (!file.Files) {
                <span><mat-icon>error</mat-icon></span>
                }
                @if (!!file.Files) {
                <span><mat-icon>check</mat-icon></span>
                }
              </td>
              <td class="column-actions">
                @for (f of file.Files; track f) {
                <div>
                  <button mat-icon-button color="primary" (click)="downloadFile(f.Id, f.Name)">
                    <mat-icon>download</mat-icon>
                  </button>
                </div>
                }
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header [collapsedHeight]="documentsExpansionHeaderHeight"
        [expandedHeight]="documentsExpansionHeaderHeight">
        <mat-panel-title>
          <h2>{{ 'EmploymentHistoryDocuments' | translate }}</h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="document-buttons">
        <button mat-raised-button color="primary" [matMenuTriggerFor]="menu">{{ 'WP-AddDocument' | translate }}</button>
        <mat-menu #menu="matMenu">
          @if (documentTypeIds?.includes(documentTypes.PIT2)) {
          <div [matTooltip]="'PIT2Tooltip' | translate" [matTooltipDisabled]="canGeneratePIT2">
            <button mat-menu-item [disabled]="!canGeneratePIT2" (click)="openPIT2Dialog()">
              {{ 'WL-PIT2' | translate }}
            </button>
          </div>
          }
          @if (documentTypeIds?.includes(documentTypes.PpkCancellation)) {
          <div [matTooltip]="'WL-PpkCancellationTooltip' | translate" [matTooltipDisabled]="canGeneratePpkResignation">
            <button mat-menu-item [disabled]="!canGeneratePpkResignation" (click)="openPpkCancellationDialog()">
              {{ 'WL-PpkCancellation' | translate }}
            </button>
          </div>
          }
          @if (documentTypeIds?.includes(documentTypes.HolidayChildCareStatement)) {
          <div [matTooltip]="'WL-ChildCareTooltip' | translate"
            [matTooltipDisabled]="canGenerateHolidayChildCareStatementDialog">
            <button mat-menu-item [disabled]="!canGenerateHolidayChildCareStatementDialog"
              (click)="openHolidayChildCareDialog()">
              {{ 'WL-HolidayChildCare' | translate }}
            </button>
          </div>
          }
        </mat-menu>
        <button mat-raised-button color="primary" (click)="openEmploymentHistoryDialog()">
          {{ 'WL-AddDocument' | translate }}
        </button>
      </div>
      <div class="table-wrapper">
        <table class="six-cols">
          <thead>
            <tr>
              <th class="column-fullname">{{ 'WL-WorkerFileType' | translate }}</th>
              <th class="column-filename">{{ 'Name' | translate }}</th>
              <th class="column-description">{{ 'Description' | translate }}</th>
              <th class="column-date">{{ 'CreatedOnDate' | translate }}</th>
              <th class="column-isattached">{{ 'Status' | translate }}</th>
              <th class="column-actions">{{ 'Actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (file of files?.DocumentFiles | filterPurely :
            sectionFilter(workerTypeSectionEnum.EmploymentHistoryFilesSection); track file) {
            @for (sFile of file.SectionFiles; track sFile) {
            <tr>
              <td class="column-fullname">
                {{ sFile.FileTypeName }}
              </td>
              <td class="column-filename">
                @for (f of sFile.WorkerFiles; track f) {
                <div>
                  <a href="javascript:void(0)" (click)="showFile(f.Id, f.Name)">{{ f.Name }}</a>
                </div>
                }
              </td>
              <td class="column-description">
                @for (f of sFile.WorkerFiles; track f) {
                <div>{{ f?.Description }}</div>
                }
              </td>
              <td class="column-date">
                @for (f of sFile.WorkerFiles; track f) {
                <div>{{ f?.CreatedOn | date : 'yyyy-MM-dd' }}</div>
                }
              </td>
              <td class="column-isattached">
                @if (!sFile.WorkerFiles) {
                <span><mat-icon>error</mat-icon></span>
                }
                @if (!!sFile.WorkerFiles) {
                <span><mat-icon>check</mat-icon></span>
                }
              </td>
              <td class="column-actions">
                @for (f of sFile.WorkerFiles; track f) {
                <div>
                  <button mat-icon-button color="primary" (click)="downloadFile(f.Id, f.Name)">
                    <mat-icon>download</mat-icon>
                  </button>
                </div>
                }
              </td>
            </tr>
            }
            }
            @for (file of files?.EmploymentHistoryFiles; track file) {
            <tr>
              <td class="column-fullname">{{ 'EmploymentHistoryFileType' | translate }}</td>
              <td class="column-filename">
                @for (f of file.Files; track f) {
                <div>
                  <a href="javascript:void(0)" (click)="showFile(f.Id, f.Name, file.EmploymentHistoryRecordId)">{{
                    f.Name }}</a>
                </div>
                }
              </td>
              <td class="column-description">
                @for (f of file.Files; track f) {
                <div>{{ f?.Description }}</div>
                }
              </td>
              <td class="column-date">
                @for (f of file.Files; track f) {
                <div>{{ f?.CreatedOn | date : 'yyyy-MM-dd' }}</div>
                }
              </td>
              <td class="column-isattached">
                @if (!file.Files) {
                <span><mat-icon>error</mat-icon></span>
                }
                @if (!!file.Files) {
                <span><mat-icon>check</mat-icon></span>
                }
              </td>
              <td class="column-actions">
                @for (f of file.Files; track f) {
                <div>
                  <button mat-icon-button color="primary"
                    (click)="downloadFile(f.Id, f.Name, file.EmploymentHistoryRecordId)">
                    <mat-icon>download</mat-icon>
                  </button>
                </div>
                }
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <!-- Documents -->
  <app-worker-documents-list *hasPermissionToModule="moduleNames.ApplicationsAndCertificates"
    [workerId]="profile.WorkerId" [documentsExpansionHeaderHeight]="documentsExpansionHeaderHeight">
  </app-worker-documents-list>
  <mat-accordion>
    <!-- Other -->
    <mat-expansion-panel>
      <mat-expansion-panel-header [collapsedHeight]="documentsExpansionHeaderHeight"
        [expandedHeight]="documentsExpansionHeaderHeight">
        <mat-panel-title>
          <h2>{{ 'AdditionalDocuments' | translate }}</h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="document-buttons">
        <button mat-raised-button color="primary" (click)="openAdditionalDocumentsDialog()">
          {{ 'WL-AddDocument' | translate }}
        </button>
      </div>
      <div class="table-wrapper">
        <table class="six-cols">
          <thead>
            <tr>
              <th class="column-filetype">{{ 'WL-WorkerFileType' | translate }}</th>
              <th class="column-date">{{ 'CreatedOnDate' | translate }}</th>
              <th class="column-description">{{ 'Description' | translate }}</th>
              <th class="column-filename">{{ 'Name' | translate }}</th>
              <th class="column-isattached">{{ 'Status' | translate }}</th>
              <th class="column-actions">{{ 'Actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (documentFile of files?.DocumentFiles | filterPurely :
            sectionFilter(workerTypeSectionEnum.AdditionalFilesSection); track documentFile) {
            <tr>
              <td class="column-filetype">
                @for (sectionFile of documentFile?.SectionFiles; track sectionFile) {
                <div>{{ sectionFile?.FileTypeName }}</div>
                }
              </td>
              <td>
                @for (sectionFile of documentFile?.SectionFiles; track sectionFile) {
                @for (workerFile of sectionFile?.WorkerFiles; track workerFile) {
                <div class="column-date">
                  {{ workerFile?.CreatedOn | date : 'yyyy-MM-dd' }}
                </div>
                }
                }
              </td>
              <td>
                @for (sectionFile of documentFile?.SectionFiles; track sectionFile) {
                <div class="column">
                  @for (workerFile of sectionFile?.WorkerFiles; track workerFile) {
                  <div class="column-description">{{ workerFile?.Description }}</div>
                  }
                </div>
                }
              </td>
              <td>
                @for (sectionFile of documentFile?.SectionFiles; track sectionFile) {
                <ng-container class="column">
                  @for (workerFile of sectionFile?.WorkerFiles; track workerFile) {
                  <div class="column-filename">
                    <a href="javascript:void(0)" (click)="showFile(workerFile.Id, workerFile.Name)">{{ workerFile.Name
                      }}</a>
                  </div>
                  }
                </ng-container>
                }
              </td>
              <td class="column-isattached">
                @for (sectionFile of documentFile?.SectionFiles; track sectionFile) {
                @if (!!sectionFile.WorkerFiles == false) {
                <span><mat-icon>error</mat-icon></span>
                }
                @if (!!sectionFile.WorkerFiles == true) {
                <span><mat-icon>check</mat-icon></span>
                }
                }
              </td>
              <td class="column-actions">
                @for (sectionFile of documentFile?.SectionFiles; track sectionFile) {
                <ng-container class="column">
                  @for (workerFile of sectionFile?.WorkerFiles; track workerFile) {
                  <div>
                    <button mat-icon-button color="primary" (click)="downloadFile(workerFile.Id, workerFile.Name)">
                      <mat-icon>download</mat-icon>
                    </button>
                    <button mat-icon-button color="primary" [visibleWithPermissions]="['DeleteWorkerFiles']"
                      (click)="deleteFile(workerFile.Id)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                  }
                </ng-container>
                }
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion>
    <!-- Other -->
    <mat-expansion-panel>
      <mat-expansion-panel-header [collapsedHeight]="documentsExpansionHeaderHeight"
        [expandedHeight]="documentsExpansionHeaderHeight">
        <mat-panel-title>
          <h2>{{ 'e-dokumenty' }}</h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="table-wrapper">
        <table class="six-cols">
          <thead>
            <tr>
              <th class="column-filetype">{{ 'WL-WorkerFileType' | translate }}</th>
              <th class="column-date">{{ 'CreatedOnDate' | translate }}</th>
              <th class="column-description">{{ 'Description' | translate }}</th>
              <th class="column-filename">{{ 'Name' | translate }}</th>
              <th class="column-isattached">{{ 'Status' | translate }}</th>
              <th class="column-actions">{{ 'Actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (sectionFile of eDocuments; track sectionFile) {
            <tr>
              <td class="column-filetype">
                <div>{{ sectionFile?.DocumentType }}</div>
              </td>
              <td>
                <ng-container>
                  <div class="column-date">
                    {{ sectionFile?.AddedDate | date : 'yyyy-MM-dd' }}
                  </div>
                </ng-container>
              </td>
              <td>
                <div class="column">
                  <ng-container>
                    <div class="column-description">{{ sectionFile?.Comments }}</div>
                  </ng-container>
                </div>
              </td>
              <td>
                <ng-container class="column">
                  <ng-container>
                    <div class="column-filename">
                      <a href="javascript:void(0)" (click)="showFile(sectionFile.Id, sectionFile.DocumentName)">{{
                        sectionFile.DocumentName }}</a>
                    </div>
                  </ng-container>
                </ng-container>
              </td>
              <td class="column-isattached">
                <ng-container>
                  @if (false) {
                  <span><mat-icon>error</mat-icon></span>
                  }
                  @if (true) {
                  <span><mat-icon>check</mat-icon></span>
                  }
                </ng-container>
              </td>
              <td class="column-actions">
                <ng-container class="column">
                  <div>
                    <button mat-icon-button color="primary"
                      (click)="downloadFile(sectionFile.Id, sectionFile.DocumentName)">
                      <mat-icon>download</mat-icon>
                    </button>
                    <button mat-icon-button color="primary" [visibleWithPermissions]="['DeleteWorkerFiles']"
                      (click)="deleteFile(sectionFile.Id)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
} @else {
<mat-accordion>
  <!-- Other -->
  <mat-expansion-panel>
    <mat-expansion-panel-header [collapsedHeight]="documentsExpansionHeaderHeight"
      [expandedHeight]="documentsExpansionHeaderHeight">
      <mat-panel-title>
        <h2>{{ 'e-dokumenty' }}</h2>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="table-wrapper">
      <table class="six-cols">
        <thead>
          <tr>
            <th class="column-filetype">{{ 'WL-WorkerFileType' | translate }}</th>
            <th class="column-date">{{ 'CreatedOnDate' | translate }}</th>
            <th class="column-description">{{ 'Description' | translate }}</th>
            <th class="column-filename">{{ 'Name' | translate }}</th>
            <th class="column-isattached">{{ 'Status' | translate }}</th>
            <th class="column-actions">{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (sectionFile of eDocuments; track sectionFile) {
          <tr>
            <td class="column-filetype">
              <div>{{ sectionFile?.DocumentType }}</div>
            </td>
            <td>
              <ng-container>
                <div class="column-date">
                  {{ sectionFile?.AddedDate | date : 'yyyy-MM-dd' }}
                </div>
              </ng-container>
            </td>
            <td>
              <div class="column">
                <ng-container>
                  <div class="column-description">{{ sectionFile?.Comments }}</div>
                </ng-container>
              </div>
            </td>
            <td>
              <ng-container class="column">
                <ng-container>
                  <div class="column-filename">
                    <a href="javascript:void(0)" (click)="showFile(sectionFile.Id, sectionFile.DocumentName)">{{
                      sectionFile.DocumentName }}</a>
                  </div>
                </ng-container>
              </ng-container>
            </td>
            <td class="column-isattached">
              <ng-container>
                @if (false) {
                <span><mat-icon>error</mat-icon></span>
                }
                @if (true) {
                <span><mat-icon>check</mat-icon></span>
                }
              </ng-container>
            </td>
            <td class="column-actions">
              <ng-container class="column">
                <div>
                  <button mat-icon-button color="primary"
                    (click)="downloadFile(sectionFile.Id, sectionFile.DocumentName)">
                    <mat-icon>download</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" [visibleWithPermissions]="['DeleteWorkerFiles']"
                    (click)="deleteFile(sectionFile.Id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </ng-container>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </mat-expansion-panel>
</mat-accordion>
}